import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import { memo, useState } from 'react';
import Form from './form';
import { FormikProps } from 'formik';
import { FamilyModalVM } from '..';

interface AccordionFilterProps {
  onSearch: () => void;
  formContext: FormikProps<FamilyModalVM>;
  disabled?: boolean;
  isEmigr?: boolean;
}

const AccordionFilterComponent = ({
  onSearch,
  formContext,
  disabled,
  isEmigr,
}: AccordionFilterProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary
        aria-controls="panel-generality-content"
        id="panel-generality-content"
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form formContext={formContext} disabled={disabled} isEmigr={isEmigr} />
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <PmiButton
              variant="outlined"
              fullWidth
              color="cdmBrandThird"
              disabled={
                !(
                  formContext.values.filter?.fiscalCode ||
                  (formContext.values.filter?.surname && formContext.values.filter?.name)
                ) || disabled
              }
              onClick={() => {
                setOpen(false);
                onSearch();
              }}
            >
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionFilterComponent.displayName = 'Accordion Filter component';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
